const key = (values) => JSON.stringify(values);
export function manufacturingExpenseMetrics(lines, { account = '', supplier = '', linkedOnly = false, currency = 'EURO' } = {}) {
  const rows = lines.filter((r) => (!account || r.account === account || (account === '__missing__' && !r.account))
    && (!supplier || r.supplier_code === supplier) && (!linkedOnly || r.processes?.length)
    && (r.currency || '__missing__') === currency);
  const accounts = new Map(), months = new Map(), suppliers = new Map();
  let total = 0, unknown = 0;
  for (const row of rows) {
    const amount = row.amount == null ? null : Number(row.amount);
    const known = amount != null && Number.isFinite(amount);
    if (known) total += amount; else unknown++;
    for (const [map, id, label] of [
      [accounts, row.account || '__missing__', row.account ? `${row.account} · ${row.account_name || 'Sin descripción'}` : 'Sin cuenta de gasto'],
      [months, row.date.slice(0, 7), row.date.slice(0, 7)],
      [suppliers, key([row.company, row.supplier_code]), `${row.company === 'iva' ? 'Ennage' : 'Genaen'} · ${row.supplier_code || 'Sin código'} · ${row.supplier_name}`],
    ]) {
      if (!map.has(id)) map.set(id, { id, label, amount: 0, unknown: 0, rows: [] });
      const group = map.get(id);
      if (known) group.amount += amount; else group.unknown++;
      group.rows.push(row);
    }
  }
  return { rows, total, unknown, invoices: new Set(rows.map((r) => key([r.company, r.invoice]))).size,
    accounts: [...accounts.values()].sort((a,b) => a.id.localeCompare(b.id)),
    months: [...months.values()].sort((a,b) => a.id.localeCompare(b.id)),
    suppliers: [...suppliers.values()].sort((a,b) => Math.abs(b.amount)-Math.abs(a.amount)) };
}
